import { Btn, Field, inputCls } from "@/components/common";
import { ExtraGuests } from "@/components/ExtraGuests";
import { X, Plus } from "lucide-react";

export const EMPTY_ROOM = {
  property_id: "", adults: 1, children: 0, age_adults: 1, age_child_5_13: 0, age_child_2_4: 0, age_infant: 0,
  total_amount: 0, payment_status: "none", acconto: 0, saldo: 0,
  acconto_method: "conto_corrente", saldo_method: "conto_corrente", no_commission: false, extra_guests: [],
};

export function GroupRooms({ rooms, onChange, roomGroups }) {
  const list = rooms || [];
  const add = () => onChange([...list, { ...EMPTY_ROOM, _uid: Math.random().toString(36).slice(2) }]);
  const del = (i) => onChange(list.filter((_, idx) => idx !== i));
  const patch = (i, p) => { const g = [...list]; g[i] = { ...g[i], ...p }; onChange(g); };
  const onTotal = (i, v) => { const t = Number(v || 0); patch(i, { total_amount: v, acconto: Math.round(t * 0.3 * 100) / 100, saldo: Math.round(t * 0.7 * 100) / 100 }); };

  return (
    <div className="rounded-md border border-sky-200 bg-sky-50/40 p-3" data-testid="group-rooms">
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-semibold text-slate-700">Camere aggiuntive del gruppo ({list.length})</span>
        <Btn type="button" variant="secondary" className="!py-1.5" onClick={add} data-testid="add-room-btn"><Plus size={14} /> Aggiungi camera</Btn>
      </div>
      <p className="text-xs text-slate-400 mb-2">Stesso nominativo e stesse date della prenotazione principale. Ogni camera ha prezzo, acconto/saldo e ospiti propri (che finiscono nella scheda Ospiti).</p>
      <div className="space-y-3">
        {list.map((r, i) => (
          <div key={r._uid || i} className="rounded-md border border-slate-200 bg-white p-3" data-testid={`group-room-${i}`}>
            <div className="flex items-center justify-between mb-2">
              <span className="text-xs font-bold text-slate-500 uppercase">Camera aggiuntiva {i + 1}</span>
              <button type="button" onClick={() => del(i)} data-testid={`del-room-${i}`} className="p-1 text-slate-400 hover:text-red-600"><X size={16} /></button>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
              <div className="col-span-2">
                <Field label="Camera">
                  <select value={r.property_id} onChange={(e) => patch(i, { property_id: e.target.value })} className={inputCls} data-testid={`room-prop-${i}`} required>
                    <option value="">Seleziona…</option>
                    {roomGroups.map(([grp, rs]) => <optgroup key={grp} label={grp}>{rs.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}</optgroup>)}
                  </select>
                </Field>
              </div>
              <Field label="Adulti"><input type="number" min="0" value={r.adults} onChange={(e) => patch(i, { adults: e.target.value, age_adults: e.target.value })} className={inputCls} /></Field>
              <Field label="Bambini"><input type="number" min="0" value={r.children} onChange={(e) => patch(i, { children: e.target.value })} className={inputCls} /></Field>
              <Field label="Bambini 5–12"><input type="number" min="0" value={r.age_child_5_13} onChange={(e) => patch(i, { age_child_5_13: e.target.value })} className={inputCls} /></Field>
              <Field label="Totale (€)"><input type="number" step="0.01" value={r.total_amount} onChange={(e) => onTotal(i, e.target.value)} className={inputCls} data-testid={`room-total-${i}`} /></Field>
              <Field label="Stato pagamento">
                <select value={r.payment_status} onChange={(e) => patch(i, { payment_status: e.target.value })} className={inputCls} data-testid={`room-pay-${i}`}>
                  <option value="none">Nessun importo</option>
                  <option value="partial">Acconto versato</option>
                  <option value="full">Saldata</option>
                </select>
              </Field>
              <Field label="Acconto (€)"><input type="number" step="0.01" value={r.acconto} onChange={(e) => patch(i, { acconto: e.target.value })} className={inputCls} /></Field>
              <Field label="Saldo (€)"><input type="number" step="0.01" value={r.saldo} onChange={(e) => patch(i, { saldo: e.target.value })} className={inputCls} /></Field>
            </div>
            <label className="flex items-center gap-2 mt-2 text-xs text-slate-600 cursor-pointer">
              <input type="checkbox" checked={!!r.no_commission} onChange={(e) => patch(i, { no_commission: e.target.checked })} className="h-3.5 w-3.5 accent-sky-600" /> Commissione non dovuta
            </label>
            <ExtraGuests guests={r.extra_guests || []} onChange={(g) => patch(i, { extra_guests: g })} />
          </div>
        ))}
      </div>
    </div>
  );
}
